import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { useTranslation, Trans } from 'react-i18next';

const ResetPasswordPage = () => {
  
  const { t } = useTranslation();

  const [password, setPassword] = useState('');
  const { resetToken } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/auth/reset-password/${resetToken}`, { password });
      alert(t('reset-password.alerts.password-update-success'));
      navigate('/login');
    } catch (err) {
      alert(t('reset-password.alerts.invalid-token'));
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-4">{t('reset-password.set-new-password')}</h2>
      <form onSubmit={handleSubmit}>
        <label className="block mb-2 text-sm font-bold">{t('reset-password.set-new-password')}</label>
        <input 
          type="password" 
          className="w-full border p-2 rounded mb-4"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          minLength="6"
        />
        <button className="w-full bg-green-600 text-white font-bold py-2 rounded">
          {t('reset-password.update-password-button')}
        </button>
      </form>
    </div>
  );
};
export default ResetPasswordPage;
